/** Pure rules for who may create/edit device groups for which organisation. */
export const canManageGroupOrg = (
  role: string | null | undefined,
  userOrgId: string | null | undefined,
  childOrgIds: string[],
  targetOrgId: string | null | undefined,
): boolean => {
  if (!targetOrgId) return false;
  if (role === "superuser") return true;
  if (role !== "admin" || !userOrgId) return false;
  return targetOrgId === userOrgId || childOrgIds.includes(targetOrgId);
};

/** Organisation ids whose groups a non-superuser may see. */
export const visibleGroupOrgIds = (userOrgId: string | null | undefined, childOrgIds: string[]): string[] =>
  userOrgId ? [userOrgId, ...childOrgIds] : [];
